import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getIncompleteTreatmentOverview,
  type IncompleteTreatmentOverviewResult,
} from '@services/api/dashboard/treatment.api'

export function useIncompleteTreatmentOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<IncompleteTreatmentOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getIncompleteTreatmentOverview, {
    enabled,
    queued,
  })
}
